import {createActionCreators, ImmerReducer} from 'immer-reducer'
import defaultAuthState, {AuthStateType, AuthUserStateType} from './state'

class Auth extends ImmerReducer<AuthStateType> {
  clientAuthenticated(user: AuthUserStateType) {
    this.isAuthenticatedApplied(true)
    this.userApplied(user)
  }
  clientCleared() {
    this.isAuthenticatedApplied(false)
    this.userReset()
  }
  isAuthenticatedApplied(isAuthenticated: boolean) {
    this.draftState.isAuthenticated = isAuthenticated
  }
  userApplied(user: AuthUserStateType) {
    this.draftState.user = user
  }
  userReset() {
    this.draftState.user = defaultAuthState.user
  }
}

export const authAC = createActionCreators(Auth)

export default Auth
